import { render, staticRenderFns } from "./audioread.vue?vue&type=template&id=0941c5e9&scoped=true&"
import script from "./audioread.vue?vue&type=script&lang=js&"
export * from "./audioread.vue?vue&type=script&lang=js&"
import style0 from "./audioread.vue?vue&type=style&index=0&id=0941c5e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0941c5e9",
  null
  
)

export default component.exports